import { getExclusiveLayerIds, getLayerIds, setSubstract } from './utils/getLayerIds';
import { isLayerTreeGroupConfig } from './utils/layerGroup.js';
const deriveStateFromConfigChildren = (config, allExclusiveLayerIds, groupExclusiveLayerIds = null, groupExcludeLayerIds = null) => {
    if (isLayerTreeGroupConfig(config)) {
        if (config.isExclusive && groupExcludeLayerIds) {
            throw new Error(`Chyba konfigurace - vnořená exkluzivní skupina '${config.groupId}'.`);
        }
        const hasSubgroup = config.children.some(isLayerTreeGroupConfig);
        if (config.exclusiveLayers && hasSubgroup) {
            throw new Error(`Chyba konfigurace - mezi exkluzivními vrstvami ve skupině '${config.groupId}' je vnořená skupina.`);
        }
        let exclusiveLayerIds = config.isExclusive ? allExclusiveLayerIds : groupExclusiveLayerIds;
        let excludeLayerIds = groupExcludeLayerIds;
        if (config.exclusiveLayers) {
            const layerIdsInGroup = getLayerIds(config);
            exclusiveLayerIds = Array.from(new Set([...layerIdsInGroup, ...(exclusiveLayerIds ?? [])]));
            if (groupExcludeLayerIds !== null) {
                excludeLayerIds = setSubstract(groupExcludeLayerIds, layerIdsInGroup);
            }
        }
        else if (config.isExclusive) {
            excludeLayerIds = getLayerIds(config);
        }
        return {
            ...config,
            isVisible: true,
            showExclusivity: false,
            isExpanded: !!config.isExpanded,
            children: config.children.map((item) => deriveStateFromConfigChildren(item, allExclusiveLayerIds, exclusiveLayerIds, excludeLayerIds)),
        };
    }
    else {
        const exclusiveLayerIds = groupExclusiveLayerIds !== null
            ? setSubstract(groupExclusiveLayerIds, [config.layerId, ...(groupExcludeLayerIds ?? [])])
            : undefined;
        return {
            ...config,
            isVisible: true,
            showExclusivity: false,
            exclusiveLayerIds,
        };
    }
};
export const deriveLayerSwitcherStateFromConfig = (config) => {
    const groups = config?.groups ?? [];
    const allExclusiveLayerIds = groups.reduce((acc, item) => [...acc, ...getExclusiveLayerIds(item)], []);
    return {
        filter: {
            value: null,
            isVisible: !!config?.enableFilter,
        },
        layers: groups.map((item) => deriveStateFromConfigChildren(item, allExclusiveLayerIds)),
        savedGroupVisibility: {},
        enableCustomLayers: !!config?.enableCustomLayers,
    };
};
//# sourceMappingURL=deriveLayerSwitcherStateFromConfig.js.map